module.exports = __webpack_public_path__ + "img/injury_treatment_icon.3f00ddb4.svg";